import React from 'react';

import Container from '../../Container';
import image from './home-girl@large.jpg';

import styles from './index.module.scss';

/* eslint-disable react/prop-types */
export default ({ locale }) => (
  <div className={styles.root}>
    <Container className={styles.content}>
      <div className={`${styles.text} ${locale === 'zh' ? styles.zh : ''}`}>
        <h2 className={styles.title}>
          {locale === 'en' ? (
            <React.Fragment>
              Learning <br /> at Kingston
            </React.Fragment>
          ) : (
            <React.Fragment>
              在京斯敦<br />學習
            </React.Fragment>
          )}
        </h2>
        <p>
          {locale === 'en' ? (
            <React.Fragment>
              Kingston International School offers an IB-PYP bilingual (English/Putonghua) programme for students aged 1
              to 11 years of age. Kingston has three campuses - the Kindergarten and Children's Centre which houses our
              early years programme for children 1 to 4 years of age, a Lower Primary campus for students from Year 1 to
              Year 3 and an Upper Primary campus for students from Year 4 to Year 6. Although we have three campuses we
              are still a small school with a community feel. We maintain small class sizes and have an English and a
              Putonghua class teacher for each class.
            </React.Fragment>
          ) : (
            <React.Fragment>
              京斯敦國際學校為一歲至十一歲的學生提供國際文憑小學雙語課程(英文／普通話)。京斯敦共有三所校舍：幼兒園及幼稚園部為一至四歲學生提供幼兒教育課程、低年級校舍供一年級至三年級學生就讀，而高年級校舍則供四年級至六年級學生就讀。雖然分成三所校舍，但我們依然是一所溫馨舒適的小型學校。我們推行小班教學，每班分別有兩位母語為普通話及英文的班主任。
            </React.Fragment>
          )}
        </p>
      </div>
      <div className={styles.image}>
        <img src={image} alt="Learning at Kingston" />
      </div>
    </Container>
  </div>
);
